import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "2030年を見据えたメ～テレのメディア変革トライアルとして、人気番組「ハピキャン」と連動したデジタルキャンプ場をSpatialで構築。ファン同士の双方向コミュニケーションを実現したメディア×メタバースの開発事例です。"

const ogpImg = "https://aitria.co.jp/images/img/cases/nagoyatv/ogp_nagoyatv.png"

export const nagoyatvPageMeta: PageMeta = {
  title: "メ～テレ「ハピキャン」メタバース空間でファンコミュニティを構築した開発事例 | Aitria（アイトリア）",
  description,
  keyword: "メタバース VR AR MR NFT Web3",
  image: ogpImg,
  url: `${SITE_URL}/cases/nagoyatv/`,
}

export const nagoyatvSchema = buildCaseStudySchema({
  slug: "nagoyatv",
  pageTitle: nagoyatvPageMeta.title,
  description: nagoyatvPageMeta.description,
  headline: "ユーザーとのコミュニケーション活性化のためのメタバース空間構築",
  alternativeHeadline: "名古屋テレビ放送株式会社",
  primaryImage: ogpImg,
  images: [ogpImg,"https://aitria.co.jp/images/img/cases/nagoyatv/top.webp"],
  clientName: "名古屋テレビ放送株式会社",
  breadcrumbLabel: "ユーザーとのコミュニケーション活性化のためのメタバース空間構築",
})
